import axios, { AxiosInstance } from 'axios';
import createNotification from 'components/Settings/Utilities/CreateNotification';

const addErrorInterceptor = (client: AxiosInstance) => {
  client.interceptors.response.use(null, (error) => {
    if (error.name !== 'CanceledError') {
      const { notShowErrorMessage, errorMessage } = error.config ?? {};
      if (!notShowErrorMessage) {
        let message = errorMessage ?? 'An error occurred.';
        if (!errorMessage && error.response?.data) {
          message = error.response.data;
        }
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        }
        createNotification('danger', message);
      }
    }
    return Promise.reject(error);
  });
};

export const netApiClient = axios.create({
  baseURL: import.meta.env.VITE_APP_DOTNETAPIURL,
  timeout: 30_000,
});
addErrorInterceptor(netApiClient);

export const nodeApiClient = axios.create({
  baseURL: import.meta.env.VITE_APP_NODEAPIURL,
  timeout: 30_000,
});
addErrorInterceptor(nodeApiClient);
